/*
 * Where a link from the server goes (an inbox message, a review request): an https page opens outside the app, one of
 * the app's own paths opens in the app, anything else is ignored. Pure, so it's tested.
 */
export type LinkTarget = { kind: 'external'; url: string } | { kind: 'internal'; path: string };

export function linkTarget(link: string | null | undefined): LinkTarget | null {
  const l = (link ?? '').trim();
  if (/^https:\/\/[^\s]+$/i.test(l)) return { kind: 'external', url: l };
  if (/^\/(?!\/)[^\s]*$/.test(l)) return { kind: 'internal', path: l };
  return null;
}
